// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__s4a3Z","colBig":"styles_colBig__3nhJm","colSmall":"styles_colSmall__20rpr"};